import LoadingButton from "components/Common/LoadingButton"
import { axiosbaseurl } from "configure"
import { validateContact } from "helpers/common_helper"
import { setUpdatedData } from "helpers/data_setters"
import React, { useEffect, useState } from "react"
import { Modal, ModalBody } from "reactstrap"

const AddBookkeeperMaster = ({
  show,
  setShow,
  settable_data,
  type,
  keeperId,
  setKeeperId,
  prefixOptions = [],
}) => {
  // Individual states for each field
  const [prefix, setPrefix] = useState("")
  const [forename, setForeName] = useState("")
  const [surname, setSurname] = useState("")
  const [preferredName, setPreferredName] = useState("")
  const [email, setEmail] = useState("")
  const [contactNumber, setContactNumber] = useState("")
  const [tradingName, setTradingName] = useState("")

  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  // get existing data
  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axiosbaseurl.get(`/bookkeeper/${keeperId}`)
        if (response.data.success) {
          setPrefix(response.data.data.prefix)
          setForeName(response.data.data.forename)
          setSurname(response.data.data.surname)
          setPreferredName(response.data.data.preferredName)
          setEmail(response.data.data.email)
          setContactNumber(response.data.data.contactNumber)
          setTradingName(response.data.data.tradingName)
        }
      } catch (error) {
        console.log(error)
      }
    }
    if (keeperId && type === "edit") getData()
  }, [keeperId])

  // reset states
  useEffect(() => {
    if (!show) {
      setPrefix("")
      setForeName("")
      setSurname("")
      setPreferredName("")
      setEmail("")
      setContactNumber("")
      setTradingName("")
      setError("")
      if (keeperId) setKeeperId("")
    }
  }, [show])

  // Handle form submission
  const handleSubmit = async e => {
    e.preventDefault()
    try {
      if (!email || !/\S+@\S+\.\S+/.test(email)) {
        setError("Valid email is required")
        return
      }
      setLoading(true)
      const { data } = await axiosbaseurl[type === "edit" ? "put" : "post"](
        `/bookkeeper/${type === "edit" ? `/${keeperId}` : ""}`,
        {
          prefix,
          forename,
          surname,
          preferredName,
          email,
          contactNumber,
          tradingName,
        }
      )

      setShow(false)
      settable_data(prev =>
        setUpdatedData(
          prev,
          {
            ...data.data,
            prefix: prefixOptions?.find(i => i.id == prefix)?.prefixName,
          } || data.status,
          type
        )
      )
    } catch (error) {
      setError(error?.response?.data?.message || error.message)
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      size="lg"
      isOpen={show}
      toggle={() => setShow(!show)}
      centered={true}
    >
      <div className="modal-content">
        <ModalBody className="px-3 ">
          <div className="d-flex justify-content-between">
            <h5 className="text-capitalize">{type} Bookkeeper</h5>
            <button
              type="button"
              className="btn-close "
              onClick={() => setShow(!show)}
            ></button>
          </div>
          <div>
            {error && <div className="alert alert-danger">{error}</div>}
          </div>
          <form onSubmit={handleSubmit} className="mt-4">
            <div className="row">
              <div className="col-md-4">
                <div className="mb-3">
                  <label>
                    Prefix <span className="text-danger">*</span>
                  </label>
                  <select
                    value={prefix}
                    onChange={e => setPrefix(e.target.value)}
                    className="form-select input-field"
                    required
                  >
                    <option value="">Select </option>
                    {prefixOptions
                      ?.slice()
                      .sort((a, b) => a.prefixName.localeCompare(b.prefixName))
                      .map(item => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.prefixName}
                          </option>
                        )
                      })}
                  </select>
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-3">
                  <label>
                    Forename <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Forename "
                    value={forename}
                    onChange={e => setForeName(e.target.value)}
                    className="form-control input-field"
                    required
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-3">
                  <label>
                    Surname <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Surname"
                    value={surname}
                    onChange={e => setSurname(e.target.value)}
                    className="form-control input-field"
                    required
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-3">
                  <label>
                    Preferred Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Preferred Name "
                    value={preferredName}
                    onChange={e => setPreferredName(e.target.value)}
                    className="form-control input-field"
                    required
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-3">
                  <label>
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    placeholder="Enter Email"
                    value={email}
                    onChange={e => setEmail(e.target.value.toLowerCase())}
                    className="form-control input-field"
                    required
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="mb-3">
                  <label>
                    Contact Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Contact Number"
                    value={contactNumber}
                    onChange={e => setContactNumber(e.target.value)}
                    className="form-control input-field"
                    onKeyDown={validateContact}
                    required
                  />
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label>
                    Employer/Trading Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Employer/Trading Name"
                    value={tradingName}
                    onChange={e => setTradingName(e.target.value)}
                    className="form-control input-field"
                    required
                  />
                </div>
              </div>
            </div>

            <div className="text-center mt-4">
              <LoadingButton loading={loading} />
            </div>
          </form>
        </ModalBody>
      </div>
    </Modal>
  )
}

export default AddBookkeeperMaster
